/** @flow */

import type { HierarchyHierarchyState } from "./types";

export const initialState: HierarchyHierarchyState = {
  requestsInProgress: 0,
  activeHierarchyTree: null,
  draftHierarchyTree: null,
  selectedOrganisationalUnit: null,
  notificationSummary: {},
  hierarchyShiftPatternSchema: null,
  notificationContacts: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  shiftPatterns: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  modals: {
    editDraft: {
      visible: false,
    },
    addDepartment: {
      visible: false,
    },
    moveDepartment: {
      visible: false,
      branch: null,
    },
    renameDepartment: {
      visible: false,
      branch: null,
    },
    deleteDepartment: {
      visible: false,
      branch: null,
    },
    deleteDepartmentWarning: {
      visible: false,
      text: null,
    },
    addEditShiftPatternModal: {
      visible: false,
      assignedShiftPattern: null,
    },
    addEditContactModal: {
      visible: false,
      notificationContact: null,
    },
  },
  error: null,
  isSidebarExpanded: false,
};

export default initialState;
